import { Route } from '@angular/router';
import { FormDesignerComponent } from './form-designer.component';

export const FormDesignerRoutes: Route[] = [
  {
    path: 'form-designer/:id',
    component: FormDesignerComponent
  }
];